/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["div.icon[_ngcontent-%COMP%]{height:64px;background-position-x:center}.inputs[_ngcontent-%COMP%]{width:100%;padding-left:30px}h3[_ngcontent-%COMP%]{font-weight:700}.modal-body[_ngcontent-%COMP%]{padding-top:20px}small[_ngcontent-%COMP%]{width:80%!important}.modal-footer[_ngcontent-%COMP%]{display:-webkit-box;display:flex}.modal-footer[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:first-child{margin-right:auto}"];
export { styles as styles };
